import React from 'react';
import { ShoppingBasket as Basketball } from 'lucide-react';

export default function BasketballHero() {
  const scrollToGenerator = () => {
    document.getElementById('basketball-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="https://images.unsplash.com/photo-1546519638-68e109498ffc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
          alt="Basketball court"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-orange-900 to-orange-800 opacity-75"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <div className="flex justify-center mb-6">
          <Basketball className="w-16 h-16 text-orange-400" />
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          Basketball Team Name Generator
        </h1>
        <p className="text-xl text-orange-100 mb-8 max-w-3xl mx-auto">
          Create the perfect name for your basketball team with our AI-powered generator.
          From streetball to professional leagues, we've got you covered.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          <span className="bg-white/20 px-4 py-2 rounded-full text-white text-sm">
            Streetball Names
          </span>
          <span className="bg-white/20 px-4 py-2 rounded-full text-white text-sm">
            Professional Teams
          </span>
          <span className="bg-white/20 px-4 py-2 rounded-full text-white text-sm">
            League Names
          </span>
        </div>
        <button 
          onClick={scrollToGenerator}
          className="bg-orange-500 text-white text-lg px-8 py-4 rounded-lg hover:bg-orange-600 transition-colors cursor-pointer"
        >
          Generate Basketball Team Names
        </button>
        <p className="mt-4 text-sm text-orange-200">
          Trusted by over 5,000+ basketball teams worldwide
        </p>
      </div>
    </div>
  );
}